export type EnquiryType = 'prints' | 'licensing' | 'assignment' | 'talk' | 'other'

export const enquiryTypes: Array<{ id: EnquiryType, label: string, hint: string }> = [
    {
        id: 'prints',
        label: 'Prints',
        hint: 'A photograph for a wall, a home or an office.'
    },
    {
        id: 'licensing',
        label: 'Licensing',
        hint: 'Editorial, publishing, campaigns or broadcast.'
    },
    {
        id: 'assignment',
        label: 'Assignment',
        hint: 'Fieldwork, documentation or a wildlife survey.'
    },
    {
        id: 'talk',
        label: 'Talk or exhibition',
        hint: 'Schools, festivals, galleries and institutions.'
    },
    {
        id: 'other',
        label: 'Something else',
        hint: 'Anything that does not fit the boxes.'
    }
]

export const isEnquiryType = (value: unknown): value is EnquiryType => {
    return typeof value === 'string' && enquiryTypes.some(type => type.id === value)
}

export const getEnquiryLabel = (value: EnquiryType): string => {
    return enquiryTypes.find(type => type.id === value)?.label ?? 'Enquiry'
}
